export const DATES_FORMAT = 'MMM d, u';
export const EXPORT_FORMAT = 'yyyy-MM-dd';
export const ONE_MEGABYTE = 1000000;
export const DATE_FORMAT_WITH_HOUR = 'MMM d, u HH:MM:SS';
